import React from "react";
import { FaXTwitter } from "react-icons/fa6";

import "./Footer.scss";
import { SOCIAL_LINK } from "components/constants";

// Simplified footer for single-page site.
// - Media Kit download kept
// - Newsletter completely removed
const ListFooterItem = [
  {
    context: "Media Kit",
    // No link = triggers download
  },
];

export default function Footer() {
  const handleMediaKit = (e) => {
    e.preventDefault();
    const element = document.createElement("a");
    element.href = require("assets/grindy_logo.zip").default;
    element.download = "grindy_logo";
    element.click();
  };

  return (
    <footer className="footer mt-auto">
      <div className="bg-dark">
        <div className="container-lg">
          <div className="footer-main">
            {/* Left column */}
            <div className="footer-brand">
              <img
                src={require("assets/images/logo-white.svg").default}
                alt="Grindy Technologies"
                className="footer-logo"
              />

              <a href="mailto:hello@grindy.io" className="footer-email">
                hello@grindy.io
              </a>

              <div className="footer-socials">
                <a
                  href={SOCIAL_LINK.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social"
                  aria-label="GitHub"
                >
                  <img
                    src={require("assets/images/icon/github.svg").default}
                    alt=""
                  />
                </a>
                <a
                  href={SOCIAL_LINK.x}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social"
                  aria-label="X"
                >
                  <FaXTwitter color="#fff" size={22} />
                </a>
              </div>
            </div>

            {/* Middle - Second slogan */}
            <div className="footer-slogan">
              Keep the grind. Keep training.
            </div>

            {/* Right column */}
            <div className="footer-links">
              <div className="footer-col">
                <div className="footer-col-title">Grindy</div>
                <ul className="footer-list">
                  {ListFooterItem.map((item, index) => (
                    <li key={index}>
                      <button
                        type="button"
                        onClick={handleMediaKit}
                        className="footer-link-btn"
                      >
                        {item.context}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <div className="container-lg">
            <div className="footer-bottom-content">
              © {new Date().getFullYear()} Grindy Technologies — All Rights Reserved
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
